import { all, call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import { clinicalAnalyticsService } from './clinicalAnalytics.service';
import {
    GET_CLIENT_OVERVIEW,
    GET_CLIENT_OVERVIEW_SUCCESS,
    GET_DOMAIN_PROGRESS,
    GET_DOMAIN_PROGRESS_SUCCESS,
    GET_GOALS_PROGRESS,
    GET_GOALS_PROGRESS_SUCCESS,
    GET_GOAL_DRILLDOWN,
    GET_GOAL_DRILLDOWN_SUCCESS,
    GET_GOAL_DRILLDOWN_SUMMARY,
    GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS,
    GET_GOAL_DRILLDOWN_TARGETS,
    GET_GOAL_DRILLDOWN_TARGETS_SUCCESS,
} from './clinicalAnalytics.types';

/** Overview */
function* getClientOverview({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(clinicalAnalyticsService.getClientOverviewService, payload.clientId);
        yield put({ type: GET_CLIENT_OVERVIEW_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Domain Progress */
function* getDomainProgress({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(clinicalAnalyticsService.getDomainProgressService, payload.clientId, payload.params);
        yield put({ type: GET_DOMAIN_PROGRESS_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Goals Progress */
function* getGoalsProgress({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(clinicalAnalyticsService.getGoalsProgressService, payload.clientId, payload.params);
        yield put({ type: GET_GOALS_PROGRESS_SUCCESS, payload: res.data });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** Goal Drilldown */
function* getGoalDrilldown({ payload }) {
    yield put({ type: GET_GOAL_DRILLDOWN_SUMMARY, payload });
    yield put({ type: GET_GOAL_DRILLDOWN_TARGETS, payload });
}

function* getGoalDrilldownSummary({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const summaryRes = yield call(
            clinicalAnalyticsService.getGoalDrilldownSummaryService,
            payload.clientId,
            payload.goalId,
            payload.params
        );
        yield put({
            type: GET_GOAL_DRILLDOWN_SUMMARY_SUCCESS,
            payload: summaryRes.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getGoalDrilldownTargets({ payload, type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const targetsRes = yield call(
            clinicalAnalyticsService.getGoalDrilldownTargetsService,
            payload.clientId,
            payload.goalId,
            payload.params
        );
        yield put({
            type: GET_GOAL_DRILLDOWN_TARGETS_SUCCESS,
            payload: targetsRes.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

export const watchClinicalAnalytics = function* watchClinicalAnalyticsSaga() {
    yield takeLatest(GET_CLIENT_OVERVIEW, getClientOverview);
    yield takeLatest(GET_DOMAIN_PROGRESS, getDomainProgress);
    yield takeLatest(GET_GOALS_PROGRESS, getGoalsProgress);
    yield takeLatest(GET_GOAL_DRILLDOWN, getGoalDrilldown);
    yield takeLatest(GET_GOAL_DRILLDOWN_SUMMARY, getGoalDrilldownSummary);
    yield takeLatest(GET_GOAL_DRILLDOWN_TARGETS, getGoalDrilldownTargets);
};
